var _rect, _rect2, _line, _line2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClassifycamLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "#0C0D0E",
    rx: 24
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 50,
    width: 100,
    height: 100,
    stroke: "#FFBE0B",
    stroke_width: 2,
    fill: "none",
    rx: 12,
    opacity: 0.8
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 100,
    x2: 170,
    y2: 100,
    stroke: "#23272D",
    stroke_width: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 30,
    x2: 100,
    y2: 170,
    stroke: "#23272D",
    stroke_width: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 20,
    fill: "#FFBE0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassifycamLogo);
export default __webpack_public_path__ + "static/media/classifycam_logo.9480fb3f10ed3db1da143e91892dba38.svg";
export { ForwardRef as ReactComponent };